import Testimonial1 from "./t1.webp";
import Testimonial2 from "./t2.webp";
import Testimonial3 from "./t3.webp";
import Testimonial4 from "./t4.webp";
import Testimonial5 from "./t5.webp";
import Testimonial6 from "./t6.webp";
import Testimonial7 from "./t7.webp";
import Testimonial8 from "./t8.webp";
import Testimonial9 from "./t9.webp";
import Testimonial10 from "./t10.webp";
export { Testimonial1, Testimonial2, Testimonial3, Testimonial4, Testimonial5, Testimonial6, Testimonial7, Testimonial8, Testimonial9, Testimonial10 };